import $ from 'jquery';

export function observeXHR() {
    (function () {
        let origOpen = XMLHttpRequest.prototype.open;
        XMLHttpRequest.prototype.open = function (method, url) {
            this.addEventListener('load', function () {
                // //console.log('publisher: XHR finished loading', method, url);
                $(document).trigger('pub:XHR:loaded');
            });
            this.addEventListener('error', function () {
                // //console.log('publisher:  XHR errored out', method, url);
                $(document).trigger('pub:XHR:error');
            });
            origOpen.apply(this, arguments);
        };
    })();
}